<template>
  <!-- 详情投票模块 -->
  <div class="vote">
    <div class="line" v-if="activityName"></div>
    <div class="show-box" v-if="activityName">
      <router-link tag="h5" class="show-tit"
                   :to="{name:'list_vote',params: {id: detailsTxte.id,active: 1}}">
        {{activityTitle}}
        <a class="show-linkmore" href="javascript:void(0);">更多</a>
      </router-link>
      <div class="swiper-container show-poll-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(v,ind) in activityName">
            <ul class="show-list">
              <li v-for="(val,i) in twoNumbers" v-if="activity[ind*2+i]">
                <a href="javascript:void(0);">
                  <router-link tag="a"
                               :to="{name:'list_preview',params: {id: detailsTxte.id,uuid: activity[ind*2+i].uuid,ind: activity[ind*2+i].file_type,activityId: activity[ind*2+i].activity_id}}">
                    <div class="pic-box">
                      <img v-if="activity[ind*2+i].thumb_path" :src="activity[ind*2+i].thumb_path" alt=""/>
                      <img v-if="activity[ind*2+i].file_path" :src="activity[ind*2+i].file_path" alt=""/>
                      <img v-if="!activity[ind*2+i] && !activity[ind*2+i].file_path" src="" alt=""/>
                      <i class="icon-time" v-if="activity[ind*2+i].time_span">{{activity[ind*2+i].time_span|formatSeconds}}</i>
                      <em class="icon-ranknum" style="top: -5px;">{{ind*2+i+1}}</em>
                    </div>
                    <p>{{activity[ind*2+i].title}}</p>

                    <div class="show-pro">
                      <div class="show-bar"
                           :style="'width:'+ activity[ind*2+i].vote_count/activity[ind*2+i].vote_sum*100+'%'"></div>
                    </div>
                  </router-link>
                  <p class="show-poll"><span>{{activity[ind*2+i].vote_count}}</span>票</p>

                  <div
                    :class="activity[ind*2+i].end_time/1 >new Date(new Date()).getTime() && (new Date()).getTime()>activity[ind*2+i].start_time?'show-btn-poll':'show-btn-poll show-btn-poll-over'"
                    :data-id="activity[ind*2+i].uuid" :activity_id="activity[ind*2+i].activity_id">
                    <i class="icon-poll"><em>+1</em></i>投票
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "vote",
    props: [
      "detailsTxte",
      "twoNumbers"
    ],
    data() {
      return {
        activity: '',      // 为他投票活动
        activityTitle: '', // 投票Title---
        activityName: '',  // 为他投票数量/2
      }
    },
    methods: {
      // 操作按钮事件
    },
    created: function () {
      var that = this;
      var pageConfig = that.detailsTxte.page_config;
      var id = this.$route.params.id;
      // 投票展示
      if (that.detailsTxte.is_vote == 1 && pageConfig && pageConfig.vote && pageConfig.vote.is_show == 1 && that.detailsTxte.type != 1) {
        that.activityTitle = pageConfig.vote.title;
        // 网友投票信息
        var getVoteList = {
          activity_id: id,
          page: 1,
          pagesize: 10,
          order: 'vote_count',
          sort: 'SORT_DESC'
        };
        // 为他投票
        that.$http.get(API.GetGetVoteList, {params: getVoteList})
          .then(function (res) {
            if (res.code == 0) {
              that.activityName = Math.floor(res.data.length / 2);
              that.activity = res.data;
              that.$nextTick(function () {
                // internet friend poll
                var swiperPoll = new Swiper('.show-poll-swiper', {
                  loop: true
                });
                new Swiper('.show-activiy-swiper', {
                  loop: true
                });
                // 图片比例
                that.PictureRatio();
              })
            } else {
              // console.log('为他投票-请求数据信息出错')
            }
          });
      } else {
        $('.dl-message').hide();
        $('.btn-detail-poll').hide();
      }
    },
    mounted: function () {
      // 操作DOM
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/detailtmplate/vote.vue